import React, {useEffect, useState} from "react";
import AuthAPI from "~/api/authApi";
import { useNavigate, useSearchParams } from "react-router-dom";

function ContinueUsingApp(){
    const navigate = useNavigate();
    const [accounts, setAccounts] = useState(null);
    useEffect(() => {
        AuthAPI.getCurrentAccount()
            .then((res) => {
                setAccounts(res.data);
            })
            .catch((err) => {
                navigate("/auth/singin", {
                    replace: true
                });
            })
    }, [])

    const handleSigninOtherAccount = () => {
        AuthAPI.signOut().then(() => {
            navigate("/auth/signin", {
                replace: true
            });
        })
    }

    return (
        <div className="px-xxl-5">
            <div className="text-center">
                <h4 className="text-body-highlight mb-4">Continue Using BreakThrough</h4>
                {
                    accounts && (
                        <div>
                            <div className="d-flex align-items-center justify-content-between text-body border-top border-bottom py-3 px-3 w-100"
                                 data-discover="true">
                                <div className="avatar avatar-xl">
                                    <img alt="avatar" className="rounded-circle" src={accounts.UserAvatarUrl}/>
                                </div>

                                <div className="d-flex flex-column align-items-start ms-3">
                                    <p className="mb-0 text-body-emphasis fw-semibold fs-9">{accounts.Email}</p>
                                    <p className="mb-0 text-body-emphasis fw-semibold fs-9">{accounts.UserName}</p>
                                </div>

                                <div className="ml-auto ms-3">
                                    <a href="/ai-chatbot" className="btn btn-bt-primary">Access</a>
                                </div>
                            </div>
                            <div className="px-3 py-3">
                                <button className="btn btn-bt-primary"
                                        onClick={handleSigninOtherAccount}
                                >Sign in with a different account</button>

                            </div>
                        </div>
                    )
                }
            </div>
        </div>
    )
}

export default ContinueUsingApp;